import * as tslib_1 from "tslib";
import { MaterialGroupBase } from "@awayjs/stage";
import { GL_DepthMaterial } from "./GL_DepthMaterial";
import { GL_DistanceMaterial } from "./GL_DistanceMaterial";
import { DepthRenderer } from "../DepthRenderer";
import { DistanceRenderer } from "../DistanceRenderer";
/**
 * @class away.pool.DefaultMaterialGroup
 */
var DefaultMaterialGroup = (function (_super) {
    tslib_1.__extends(DefaultMaterialGroup, _super);
    function DefaultMaterialGroup(stage) {
        return _super.call(this, stage, DefaultMaterialGroup._abstractionClassPool) || this;
    }
    /**
     *
     * @param imageObjectClass
     */
    DefaultMaterialGroup.registerAbstraction = function (materialClassGL, assetClass) {
        DefaultMaterialGroup._abstractionClassPool[assetClass.assetType] = materialClassGL;
        DepthRenderer._abstractionClassPool[assetClass.assetType] = GL_DepthMaterial;
        DistanceRenderer._abstractionClassPool[assetClass.assetType] = GL_DistanceMaterial;
    };
    return DefaultMaterialGroup;
}(MaterialGroupBase));
export { DefaultMaterialGroup };
DefaultMaterialGroup._abstractionClassPool = new Object();



// WEBPACK FOOTER //
// ../dist/lib/materials/DefaultMaterialGroup.js